import React from "react";
import { Link } from "gatsby";
const ListLink = props => (
  <li style={{ display: `inline-block`, marginRight: `1rem` }}>
    <Link to={props.to}>{props.children}</Link>
  </li>
);
export default function Layout({ children }) {
  return (
    <div style={{ margin: `0.5rem auto`, maxWidth: 1000, padding: `0 0.5rem` }}>
      <header style={{ marginBottom: `1.5rem` }}>
        <Link to="/" style={{ textShadow: `none`, backgroundImage: `none` }}>
          <h3 style={{ display: `inline` }}>MyJournal</h3>
        </Link>
        <ul style={{ listStyle: `none`, float: `right` }}>
          <ListLink to="/">Home</ListLink>
          <ListLink to="/memes/">Memes</ListLink>
          <ListLink to="/projects/">Projects</ListLink>
          <ListLink to="/football/">Football Matches</ListLink>
          <ListLink to="/people/">People</ListLink>
          <ListLink to="/movies/">Movies</ListLink>
          <ListLink to="/games/">Games</ListLink>
          <ListLink to="/dates/">Cards</ListLink>
          <ListLink to="/location/">Locations</ListLink>
          <ListLink to="/audio/">Audio</ListLink>
          <ListLink to="/about/">Happy Birthday</ListLink>
          {/* <ListLink to="/movies/">BucketList</ListLink> */}
        </ul>
      </header>
      {children}
    </div>
  );
}
